import type { FeedbackMessages } from './en';

const et: FeedbackMessages = {
  qualified: {
    title: 'Täname, et vastasite sellele küsitlusele!',
    body1: 'Võite brauseriakna vabalt sulgeda.',
    body2: 'Loodame Teid peagi taas näha.',
    refCode: 'Viitekood: {code}',
  },
  quotaFull: {
    title: 'See küsitlus on suletud',
    body1: 'Täname huvi vastu meie küsitluse suhtes.',
    body2: 'Kahjuks oleme juba saanud kõik vajalikud vastused.',
    body3: 'Loodame Teid näha mõnes meie tulevases küsitluses!',
    refCode: 'Viitekood: {code}',
  },
  terminated: {
    title: 'Täname tagasiside jagamise eest!',
    body1:
      'Loodame Teid peagi näha mõnes meie tulevases küsitluses. Kuni siis soovime Teile ilusat päeva.',
    body2: 'Palun sulgege see brauseriaken.',
    refCode: 'Viitekood: {code}',
  },
  mismatch: {
    title: 'Täname huvi vastu',
    body1: 'Kahjuks ei kuulu Te selle konkreetse küsitluse sihtgruppi.',
    body2: 'Võite selle lehe sulgeda.',
    code: 'Kood: {code}',
  },
  error: {
    title: 'Teie taotlust ei saa täita',
    linkProblemDetailed:
      'Lingiga, mida kasutasite, on probleeme. Palun kontrollige, et aadressiribal olev link vastab Teile antud lingile, ning proovige uuesti.',
    linkProblemGeneric:
      'Lingiga, mida kasutasite, on probleeme. Palun proovige uuesti.',
    contactPerson:
      'Kui probleem püsib, palun teavitage sellest isikut, kellelt saite lingi.',
    errorCode: 'Veakood: {code}',
  },
};

export default et;
